module.exports = __webpack_public_path__ + "static/media/CBSE2018.ab8aff14.jpg";